// extracted by mini-css-extract-plugin
export default {"mainContainer":"login_mainContainer__9HSNG"};